export namespace FareReviewStatusConstants {
  export const AWAITING_CALCULATION = 'Awaiting calculation';
  export const NOT_REQUIRED = 'Not required';
  export const REQUIRED = 'Required';
  export const IN_PROGRESS = 'In progress';
  export const COMPLETED_NOT_ADJUSTED = 'Completed not adjusted';
  export const COMPLETED_ADJUSTED = 'Completed adjusted';
  export const NOT_ELIGIBLE = 'Not Eligible';
  export const AWAITING_TOLL_CONFIRMATION = 'Awaiting toll confirmation';
}
